module.exports = __webpack_public_path__ + "static/media/5 SHPETina Showcase.7d881c18.JPG";